"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var ssrcontext_1 = require("./ssrcontext");
var app_1 = require("services/page/app");
function getInitialProps(runtime, statsdCb) {
    return __awaiter(this, void 0, Promise, function () {
        var countryCode, languageCode, platform, currency, slug, id, version, api, hostname, userAgent, href, search, origin, customerId, meta, initialProps, time, frontPlaygroundResponse, moduleIds, result_1, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    countryCode = runtime.countryCode, languageCode = runtime.languageCode, platform = runtime.platform, currency = runtime.currency, slug = runtime.slug, id = runtime.id, version = runtime.version, api = runtime.api, hostname = runtime.hostname, userAgent = runtime.userAgent, href = runtime.href, search = runtime.search, origin = runtime.origin, customerId = runtime.customerId;
                    ssrcontext_1.updateStore({
                        countryCode: countryCode,
                        languageCode: languageCode,
                        currencyCode: currency,
                        platform: platform,
                        api: api,
                        hostname: hostname,
                        userAgent: userAgent,
                        id: id,
                        href: href,
                        search: search,
                        origin: origin,
                        cookies: statsdCb.cookies,
                        customerId: customerId
                    });
                    meta = {
                        catalog: countryCode,
                        lang: languageCode,
                        client: platform,
                        priceSymbol: currency
                    };
                    initialProps = {
                        meta: meta,
                        frontPlayground: {
                            modules: [],
                            page: {},
                            activityId: ""
                        },
                        frontModules: []
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    time = Date.now();
                    return [4, app_1.GetFrontPlayground({ slug: slug, version: version, id: id, meta: meta })];
                case 2:
                    frontPlaygroundResponse = _a.sent();
                    if (frontPlaygroundResponse) {
                        statsdCb && statsdCb.statsdForSuccess("page_App_GetFrontPlayground", time);
                    }
                    if (!(frontPlaygroundResponse &&
                        frontPlaygroundResponse.modules &&
                        frontPlaygroundResponse.modules.length > 0)) return [3, 4];
                    initialProps.frontPlayground.modules = frontPlaygroundResponse.modules;
                    initialProps.frontPlayground.page = frontPlaygroundResponse.page;
                    initialProps.frontPlayground.activityId =
                        frontPlaygroundResponse.page && frontPlaygroundResponse.page.groupId;
                    moduleIds = frontPlaygroundResponse.modules.map(function (i) { return i.id; });
                    time = Date.now();
                    return [4, app_1.GetFrontModules({
                            moduleId: moduleIds,
                            meta: meta
                        })];
                case 3:
                    result_1 = _a.sent();
                    if (result_1) {
                        statsdCb && statsdCb.statsdForSuccess("page_App_GetFrontModules", time);
                    }
                    if (result_1 && result_1.mods) {
                        initialProps.frontModules = frontPlaygroundResponse.modules.reduce(function (memo, item) {
                            var module = result_1.mods[item.id];
                            if (module) {
                                return __spreadArrays(memo, [module]);
                            }
                            return __spreadArrays(memo);
                        }, []);
                    }
                    _a.label = 4;
                case 4: return [3, 6];
                case 5:
                    error_1 = _a.sent();
                    statsdCb && statsdCb.statsdForFailure("page_App_frontPlayground");
                    console.error(error_1);
                    return [3, 6];
                case 6: return [2, __assign(__assign({}, initialProps), { cookies: statsdCb.cookies })];
            }
        });
    });
}
exports.default = getInitialProps;
